import { render, staticRenderFns } from "./setVideoDevInfo.vue?vue&type=template&id=3428dea4&scoped=true&"
import script from "./setVideoDevInfo.vue?vue&type=script&lang=js&"
export * from "./setVideoDevInfo.vue?vue&type=script&lang=js&"
import style0 from "./setVideoDevInfo.vue?vue&type=style&index=0&id=3428dea4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3428dea4",
  null
  
)

export default component.exports